<div class="results-container" *ngIf="(locationSearchResults$ | async) !== null">    
    <div class="search-breadcrumb">
        <div
            (click)="clearSearch()" 
            [class]="locale === 'es-US' ? 'search-breadcrumb-item-spanish' : 'search-breadcrumb-item'">
            {{breadcrumbText}}
        </div>
        <div class="search-breadcrumb-arrow" style="display: flex;">
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
                <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div *ngIf="locale !== 'es-US' && queryNameOrSpecialty !== '' && queryNameOrSpecialty !== null && showSpinner === false" class="search-breadcrumb-item-2">{{breadcrumbText2}} "{{queryNameOrSpecialty}}"</div>
        <div *ngIf="locale === 'es-US' && queryNameOrSpecialty !== '' && queryNameOrSpecialty !== null && showSpinner === false" class="search-breadcrumb-item-2">{{breadcrumbText2}} "{{queryNameOrSpecialty}}"</div>
        <div *ngIf="queryNameOrSpecialty === '' || queryNameOrSpecialty === null || showSpinner === true" class="search-breadcrumb-item-2">{{breadcrumbText2}}</div> 
    </div>

  <!-- Location filter and sort/filter icons -->
  <div *ngIf="showSpinner === false" class="filter-toolbar">
    <div class="location-filter" (click)="toggleLocationMenu()">
      <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="location-pin">
        <path d="M12.9514 0L7.64368 13.1333L5.83571 7.35412L0.000118644 5.73751L12.9514 0Z" fill="#959595"/>
      </svg>
      <span>{{queryCityOrZip}} ({{distanceInMiles}} {{mileLabel}})</span>
      <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg" class="dropdown-arrow">
        <path d="M9 0H0L4.76471 4.5L9 0Z" fill="#8B8B8B"/>
      </svg>
    </div>
    
    <div *ngIf="showSpinner === false" class="toolbar-actions">
      <button mat-icon-button [matMenuTriggerFor]="sortMenu" class="icon-btn">
        <app-sort-icon-svg></app-sort-icon-svg>
      </button>
      <button class="icon-btn" (click)="toggleFilter()">
        <app-filter-icon-svg></app-filter-icon-svg>
        <div *ngIf="appliedFilterCount > 0" class="filter-display-toggle-count-web">{{appliedFilterCount}}</div>
      </button>
    </div>
  </div>

  <!-- Sort Menu -->
  <mat-menu #sortMenu="matMenu" class="sort-menu-container">
    <div (click)="$event.stopPropagation()">
      <div class="menu-label-sort">
        {{sortByTitle}}
      </div>
      <div class="menu-radio-option">
        <input type="radio" 
          id="sort-distance" 
          name="locationSort" 
          value="distance" 
          [(ngModel)]="locationSortMethod" 
          (change)="onApplySortMethod('distance')">
        <label for="sort-distance">{{distanceLabel}}</label>
      </div>
      <div class="menu-radio-option">
        <input type="radio" 
          id="sort-availability" 
          name="locationSort" 
          value="availability" 
          [(ngModel)]="locationSortMethod" 
          (change)="onApplySortMethod('availability')">
        <label for="sort-availability">{{availabilityLabel}}</label>
      </div>
      <div class="menu-radio-option">
        <input type="radio" 
          id="sort-name" 
          name="locationSort" 
          value="name" 
          [(ngModel)]="locationSortMethod" 
          (change)="onApplySortMethod('name')">
        <label for="sort-name">{{nameLabel}}</label>
      </div>
    </div>
  </mat-menu>

  <!-- Results count -->
  <div  *ngIf="showSpinner === false" class="results-count">
    {{resultsText}} ({{(locationSearchResults$ | async)?.length || 0}})
  </div>

  <!-- Results List -->
  <div *ngIf="showSpinner === false" class="results-list">
    <app-location-search-results-card-mobile
      *ngFor="let location of (locationSearchResults$ | async)"
      [location]="location"
      [isPlus]="isPlus"
      [queryCityOrZip]="queryCityOrZip">
    </app-location-search-results-card-mobile>
  </div>

  <div  *ngIf="showSpinner === true">
    <div class="spinner-container">
      <mat-spinner></mat-spinner>
    </div>
  </div>
</div>
